import { PageSort } from './page.model';

export class PageableModel {
  constructor(public page: number = 0, public size: number = 10, public sort?: PageSort) {}
}
